import type { WebLocale } from '@/enums/web-locale';
import type { UCConfigInterface } from '@/libraries/usercentrics/types';

import { GDPR_WEB_LOCALES } from '@/constants/web-locales.constant';
import { hasCCPABanner } from '@/helpers/tracking';

export const UC_TCF_LOCALSTORAGE_KEY: string = 'uc_tcf';

// Hostname-based configuration
function isMovieCycleDomain(): boolean {
	// UserCentrics only runs on client side (in onMounted), so this is safe
	if (import.meta.server || typeof window === 'undefined') {
		// On server or when window is not available, default to production config
		// This is safe because UserCentrics is only initialized on the client
		return false;
	}

	// On client, check if hostname contains 'moviecycle'
	return window.location.hostname.includes('moviecycle');
}

export const TCF_PROFILE: UCConfigInterface = {
	// Use stage config (JZOgttDwQ) for moviecycle domains, production config (pNbv5DOWe) otherwise
	configId: isMovieCycleDomain()
		? 'JZOgttDwQ'
		: 'pNbv5DOWe',
	isTCFEnabled: true,
};

export const CCPA_PROFILE: UCConfigInterface = {
	configId: 'p9i1nfAVcBcGYb',
	isTCFEnabled: false,
};

export function getUserCentricsConsentProfile(webLocale: WebLocale): UCConfigInterface {
	// GDPR locales always use the TCF profile, regardless of the user's geo-location.
	// This lets Usercentrics start loading before the geo lookup resolves, and avoids a wrong profile
	// from a missing or stale cached subdivision (the profile can't be changed once Usercentrics has loaded).
	if (GDPR_WEB_LOCALES.includes(webLocale)) return TCF_PROFILE;

	return hasCCPABanner()
		? CCPA_PROFILE
		: TCF_PROFILE;
}
